import type { SVGProps } from 'react';

const SvgPlayerLoopPingpong = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M8 9h7.59l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41l-3-3a.996.996 0 1 0-1.41 1.41l1.29 1.29H8.01c-2.76 0-5 2.24-5 5 0 .55.45 1 1 1s1-.45 1-1c0-1.65 1.35-3 3-3z"
    />
    <path
      fill="currentcolor"
      d="M20 15H8.41l1.29-1.29a.996.996 0 1 0-1.41-1.41l-3 3a.996.996 0 0 0 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29h11.59c.55 0 1-.45 1-1s-.45-1-1-1z"
    />
  </svg>
);
export default SvgPlayerLoopPingpong;
